const routes = [
  {
    path: '/survey',
    name: 'survey',
    component: () => import('@/modules/survey/pages/Entry.vue'),
    meta: {
      requiresAuth: true,
      title: 'eRank — Get to Know You Survey',
      metaTags: [
        {
          name: 'description',
          content: 'Take a short survey to tell eRank more about your business and goals. Your answers help us understand our users better so we can keep improving eRank.',
        },
        {
          page_slug: 'survey',
        },
      ],
    },
    children: [
      {
        path: ':id',
        name: 'survey.entry',
        component: () => import('@/modules/survey/pages/Step.vue'),
      },
    ],
  },
];
  
export default routes;
  